import { FormattedMessage } from 'react-intl'

interface Props {
  cabinType?: string
  isBundle?: boolean
}

export default function CruisePriceFromLabel({ cabinType, isBundle = false }: Props) {
  if (isBundle && cabinType) {
    return <FormattedMessage
      id="71tfUVmm_bcI8JwrHylI"
      defaultMessage="{cabinType} + Hotel from"
      description="Starting price caption for a cruise cabin category packaged with a hotel stay"
      values={{ cabinType }}
    />
  }

  if (cabinType) {
    return <FormattedMessage
      id="OWqPk_LWR750wyY4ehdh"
      defaultMessage="{cabinType} from"
      description="Price caption showing the cruise cabin type before the starting price"
      values={{ cabinType }}
    />
  }

  return <FormattedMessage
    id="_i1oXTT5R-RrHGEZFIar"
    defaultMessage="From"
    description="Price caption shown before a cruise starting price without a promotion"
  />
}
